import React from "react";

export default function Footer() {
  return (
    <div className="layout-footer">
      <span className="font-medium ml-2">WARDAH DASHBOARD</span>
    </div>
  );
}
